import Component from 'flarum/common/Component';
import LinkButton from 'flarum/common/components/LinkButton';
export default class MobileTabItem extends Component {
  view(vnode) {
    var _this$attrs$external;
    return m(LinkButton, {
      className: "MobileTab-item",
      href: this.attrs.href,
      icon: this.attrs.icon,
      target: this.attrs.target,
      external: (_this$attrs$external = this.attrs.external) != null ? _this$attrs$external : false
    }, vnode.children);
  }
}
flarum.reg.add('acpl-mobile-tab', 'forum/components/MobileTabItem', MobileTabItem);